import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert } from 'reactstrap';
import './Register.css';

const Register = () => {
  const [nama, setNama] = useState('');
  const [email, setEmail] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [kodePendaftaran, setKodePendaftaran] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (kodePendaftaran !== "rla165165") {
      setError("Pastikan anda memiliki akses yang sah!");
      return;
    }

    if (password !== confirmPassword) {
      setError("Konfirmasi password tidak sesuai!");
      return;
    }

    const username = email.split('@')[0]; // Buat username dari email
    const userData = {
      nama,
      email,
      whatsapp,
      username,
      password,
      confirm_password: confirmPassword,
    };

    try {
      const response = await fetch('https://cendekiasolusi.com/api/registerUser.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userData),
      });

      const result = await response.json();
      if (result.status === "success") {
        setSuccess("Pendaftaran berhasil! Mengarahkan ke Dashboard...");
        setTimeout(() => navigate('/Admin/Dashboard'), 2000);
      } else {
        setError(result.message || "Pendaftaran gagal!");
      }
    } catch (err) {
      setError("Terjadi kesalahan! Coba lagi nanti.");
    }
  };

  return (
    <div className='register-box'>
      <div className='register-box-body'>
        <div className="register-container">
          <form className="register-form" onSubmit={handleRegister}>
            <h2>Daftar Administrator</h2>
            <hr 
              style={{
                marginBottom: '30px',
                width: '100%',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            />
            {error && <Alert color="danger">{error}</Alert>}
            {success && <Alert color="success">{success}</Alert>}

            <input type="text" placeholder="Nama Lengkap" value={nama} onChange={(e) => setNama(e.target.value)} required />
            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <input type="tel" placeholder="No WhatsApp" value={whatsapp} onChange={(e) => setWhatsapp(e.target.value)} required />
            <hr 
              style={{
                marginBottom: '10px',
                width: '70%',
                marginLeft: 'auto',
                marginRight: 'auto',
                border:'none'
              }}
            />

            <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            <input type="password" placeholder="Ulangi Password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
            <input type="text" placeholder="Kode Pendaftaran" value={kodePendaftaran} onChange={(e) => setKodePendaftaran(e.target.value)} required />

            <button type="submit">Daftar</button>
            <p className="register-nav-login">
              Sudah punya akun? <a href="/admin/login">LOGIN</a> {/* Perbaiki link daftar */}
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
